import React from 'react'
import { ElementClicksTag } from './ElementClickTag'

import {
  EyeSvg,
  ClickSvg,
  DoubleCheckSvg,
  WebSvg
} from '../../components/Icons'

import { parseTextToHTML } from '../../libs/parse'

const BUTTON_ELEMENT = 'button'
const SUGGESTION_ELEMENT = 'suggestion'

export const RichCardStats = ({ elementInfo, onNavigateToStep }) => {
  return (
    <section id="richCardColumn" className="w-full max-w-sm">
      <div id="richCard" className="border-2 border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm">
        <img
          className="aspect-video object-cover w-full"
          src={elementInfo.image || elementInfo.imageUrl}
          alt={elementInfo.title || 'RichCard image'}
        />
        <div className="p-4">
          {elementInfo.title && (
            <p className="font-semibold text-base mb-2 text-gray-900">
              {parseTextToHTML(elementInfo.title)}
            </p>
          )}
          {elementInfo.description && (
            <p className="font-light text-sm text-gray-600 mb-3">
              {parseTextToHTML(elementInfo.description)}
            </p>
          )}
          {elementInfo.buttons && elementInfo.buttons.length > 0 && (
            <div className="space-y-2">
              {elementInfo.buttons.map((button, idx) => {
                const buttonData = {
                  text: button.text || button.displayText || '',
                  clicks: button.clicks || 0,
                  postback: button.postback,
                  openUrl: button.openUrl,
                  type: button.type
                }
                
                if (!buttonData.text && buttonData.postback) {
                  const postbackParts = buttonData.postback.split('-')
                  if (postbackParts.length > 1) {
                    const meaningfulParts = postbackParts.slice(1).filter(part => 
                      part && !part.match(/^\d+\/\d+$/) && !part.includes('parent')
                    )
                    if (meaningfulParts.length > 0) {
                      buttonData.text = meaningfulParts.join(' ').replace(/_/g, ' ').trim()
                    }
                  }
                }
                
                if (!buttonData.text) return null
                
                return (
                  <ElementClicksTag
                    key={idx}
                    elementInfo={buttonData}
                    elementType="button"
                    onClick={onNavigateToStep}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
      
      {/* Suggestions/Options with clicks */}
      {elementInfo.suggestions && elementInfo.suggestions.length > 0 && (
        <div id="suggestionsGroup" className="mt-4">
          <h3 className="text-sm font-semibold text-gray-700 mb-3">Response Options:</h3>
          <div className="flex flex-col gap-3">
            {elementInfo.suggestions.map((suggestion, index) => {
              // Extract text and postback from suggestion
              const suggestionData = {
                text: suggestion.text || suggestion.displayText || '',
                clicks: suggestion.clicks || 0,
                postback: suggestion.postback,
                openUrl: suggestion.openUrl,
                type: suggestion.type
              }
              
              if (!suggestionData.text && suggestionData.postback) {
                const postbackParts = suggestionData.postback.split('-')
                if (postbackParts.length > 1) {
                  const meaningfulParts = postbackParts.slice(1).filter(part => 
                    part && !part.match(/^\d+\/\d+$/) && !part.includes('parent')
                  )
                  if (meaningfulParts.length > 0) {
                    suggestionData.text = meaningfulParts.join(' ').replace(/_/g, ' ').trim()
                  }
                }
              }
              
              if (!suggestionData.text) return null
              
              console.log(`[RichCardStats] Rendering suggestion ${index}:`, {
                text: suggestionData.text,
                postback: suggestionData.postback,
                hasPostback: !!suggestionData.postback,
                hasOnNavigateToStep: !!onNavigateToStep,
                suggestionData
              })
              
              return (
                <ElementClicksTag
                  key={index}
                  elementInfo={suggestionData}
                  elementType={SUGGESTION_ELEMENT}
                  onClick={onNavigateToStep}
                />
              )
            })}
          </div>
        </div>
      )}
    </section>
  )
}
